import Swal from "sweetalert2";
import PropTypes from 'prop-types';
import Panel from "@/shared/components/Panel";
import { ResponsiveContainer } from 'recharts';
import React, { useEffect, useState } from 'react';
import AdminInterface from '@/utils/AdminInterface';
import withReactContent from "sweetalert2-react-content";
import ReactTableBase from '@/shared/components/table/ReactTableBase';

const APIUsagesByCollectionList = () => {
    const [APIUsagesList, setAPIUsagesList] = useState({ tableHeaderData: [], tableRowsData: [] });
    const tableConfig = {
        isEditable: false,
        isSortable: true,
        isResizable: false,
        withPagination: false,
        withSearchEngine: false,
    };

    const GetAPIUsagesData = () => {
        AdminInterface.instance.getServiceUsageByCollection().then((response) => {
            const columns = [
                {
                    accessor: 'collection',
                    Header: 'Collection',
                    disableGlobalFilter: true,
                    disableSortBy: true,
                },
                {
                    accessor: 'count',
                    Header: 'Count',
                    disableGlobalFilter: true,
                    disableSortBy: true,
                }
            ];
            const data = [];
            for (let collection in response.data) {
                data.push({
                    collection: collection,
                    count: response.data[collection]
                });
            }

            const APIUsagesListTableData = { tableHeaderData: columns, tableRowsData: data };
            setAPIUsagesList(APIUsagesListTableData);
        }).catch((error) => {
            withReactContent(Swal).fire({
                title: "Error",
                html: error.response.data?.detail,
            });
        })
    };

    useEffect(() => {
        GetAPIUsagesData();
    }, []);

    return (
        <Panel lg={12} xl={12} md={12} title='API Usages By Collection' refreshRequest={() => GetAPIUsagesData()}>
            {APIUsagesList && <ResponsiveContainer height={500}>
                <ReactTableBase
                    columns={APIUsagesList.tableHeaderData}
                    data={APIUsagesList.tableRowsData}
                    tableConfig={tableConfig}
                />
            </ResponsiveContainer>}
        </Panel>
    );
};

APIUsagesByCollectionList.propTypes = {
    APIUsagesListTableData: PropTypes.shape({
        tableHeaderData: PropTypes.arrayOf(PropTypes.shape({
            key: PropTypes.string,
            name: PropTypes.string,
        })),
        tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
    }).isRequired,
};

export default APIUsagesByCollectionList;
